module.exports = __webpack_public_path__ + "static/winners-ace2be5ecc31ce89de3571e014dc3e74.jpg";